import React, { createContext, useContext, useState, useEffect, useCallback } from "react";
import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const BackgroundsContext = createContext(null);

export function BackgroundsProvider({ children }) {
  const [map, setMap] = useState({});

  useEffect(() => {
    axios.get(`${API}/backgrounds`)
      .then((res) => {
        if (Array.isArray(res.data)) {
          const m = {};
          res.data.forEach((b) => { m[b.section] = b; });
          setMap(m);
        }
      })
      .catch(() => {});
  }, []);

  const get = useCallback((section) => map[section] || null, [map]);

  return (
    <BackgroundsContext.Provider value={{ get }}>
      {children}
    </BackgroundsContext.Provider>
  );
}

export function useBackgrounds() {
  return useContext(BackgroundsContext) || { get: () => null };
}
